"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var UploadOverlay = /** @class */ (function (_super) {
    tslib_1.__extends(UploadOverlay, _super);
    function UploadOverlay(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setRef = function (el) {
            _this.input = el;
        };
        _this.onChange = function (e) {
            var onChange = _this.props.onChange;
            onChange && onChange(e);
            _this.input.value = "";
        };
        _this.input = null;
        return _this;
    }
    UploadOverlay.prototype.render = function () {
        var _a = this.props, className = _a.className, theme = _a.theme, onChange = _a.onChange, others = tslib_1.__rest(_a, ["className", "theme", "onChange"]);
        var classes = classnames_1.default(theme["upload-overlay"], className);
        return (React.createElement("input", tslib_1.__assign({ className: classes, ref: this.setRef, type: "file", onChange: this.onChange }, others)));
    };
    UploadOverlay.defaultProps = {};
    return UploadOverlay;
}(React.Component));
exports.default = UploadOverlay;
